import { useState, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getFocus, useAtom, useGet, useSet } from "state/jotai";
import { toggle_drawer } from "state/actions";
import {
  active_project,
  current_language,
  filter_State,
  isMulti_project_active,
  iso_free,
  iso_isrotating,
  params_query,
  previousUrl,
  turn_building,
  vis_desktop_nav,
  vis_mobile_nav,
  vis_showOldSlider,
} from "state/store.global";
import { favorites, compares, vis_compare } from "state/store.global";
import { useFetch_Colors } from "hooks/fetch/useFetch_Colors";
import { useFetch_Navigation } from "hooks/fetch/useFetch_Navigation";
import { Icon } from "assets/Icons_";
import { Logo } from "./Nav.Logo";
import { Foldout } from "./Nav.Mobile.Foldout";

    // import LanguageMenu              from 'components/LanguageMenu/LanguageMenu'

import { Menu, Gap, Section, Text, BackBox, CarratLeft, CarratRight } from "./Nav.Mobile.style";
import NavItems from "./NavItems";
import { useBreak } from "hooks/useBreak";
import { Box } from "@mui/material";
import { _bootstrap } from "state/store.bootstrap";
import { ShiftProperty } from "components/ShiftProperty/ShiftProperty";
import { getIsoData } from "state/jotai.isometryDataHooks";
import { _project } from "state/store.projects";
import { BackButton } from "components/Button/BackButton";
import { FooterButton } from "components/DualMenu/DualMenu.style";
import { ETStyledButton } from "components/Button/EusButton";
import { isIframeMode } from "logging/logging";
import { OverviewBack } from "components/Isometry/OverviewBack";

export const NavMobile = () => {
  const here = useLocation().pathname;
  const isMobile = useBreak("md_dn");
  const { pin, pid } = useGet(active_project);
  const config = getIsoData("config");

  const { clr } = useFetch_Colors();
  const { nav } = useFetch_Navigation();
  const [show, setShow] = useAtom(vis_mobile_nav);
  const buttonsLabel = getFocus(_project, "buttonsLabel")?.[pin]?.[pid] ?? [];

  const [filterState, setFilterState] = useAtom(filter_State);
  
  const language = useAtom(current_language)[0];

  const [, setShowMenu] = useAtom(vis_desktop_nav);
  const [url] = useAtom(previousUrl);

  const navigateTo = useNavigate();
  const params = useGet(params_query);
  const toggleDrawer = useAtom(toggle_drawer)[1];
  const comptoggle = useAtom(vis_compare)[1];
  
  const compCount = useAtom(compares)[0].length;
  const likeCount = useAtom(favorites)[0].length;
  
  const rotatemode = useGet(iso_free);
  const setRotatemode = useSet(iso_free);
  const isrotate = useGet(iso_isrotating);
  const setIsrotate = useSet(iso_isrotating);
  
  const [turnBuilding, setIsTurnBuilding] = useAtom(turn_building);
  const [showProperty, setShowProperty] = useState(false);
  const [state, setState] = useState(false);
  
  const projectType = getFocus(_bootstrap, "type");
  const menus = getFocus(_project, "menuItems")?.[pin]?.[pid] ?? [];
  const multiActive = useAtom(isMulti_project_active)[0];
  const showOldSlider = useGet(vis_showOldSlider);

  // Extract the Forside URL
  const menuItemOrder10 = menus.find((item) => item.Order === "10");
  const logoUrl = menuItemOrder10 ? menuItemOrder10.URL : "https://axelhave.dk/";

  // Route checks
  const atModel = here.includes("isometry");
  const atList = here.includes("list");
  const atUnit = here.includes("unit");
  const atFavorites = here.includes("favorites");
  const atCompare = here.includes("compare");
  const atDownloads = here.includes("downloads");
  const atGallery = here.includes("gallery");

  // Filter visibility logic
  const hideFilterRoutes = ["compare", "gallery", "downloads", "unit"];
  const filterShouldShow = !hideFilterRoutes.some((route) => here.includes(route));
  
  const showButtonRoutes = ["list", "compare", "favorites", "gallery", "downloads"];
  const showButton = showButtonRoutes.some((route) => here.includes(route));
const isIsometry = here.includes("isometry");
  const IsList    = here.includes("list");
    const iFrameEnabled = isIframeMode();
  // Icon configurations
  const heart = { color: clr.icons, icon: "heart7", size: 28, count: likeCount };
  const comp = { color: clr.icons, icon: "compare3", size: 28, count: compCount };
  const bars = { color: clr.icons, icon: "three_bars", size: "xl", click: () => setShow(!show) };
  const close = { color: clr.icons, icon: "close1", size: 25, click: () => setShow(!show) };
  const globe = {
    color: clr.icons,
    icon: "globe",
    size: 28,
    click: () => setState(!state),
  };
  const glarr = {
    color: clr.icons,
    icon: "globe_arrow",
    size: 10,
    click: () => setState(!state),
    wrap: {
      position: "absolute",
      bottom: -8,
      right: -10,
      transform: state ? "rotate(180deg)" : "rotate(0deg)",
    },
  };

  const filter = { size: "lg", icon: "filters", color: "#000" };

  // Memoized callbacks
  const clickHelp = useCallback(() => {
    navigateTo(`${language}/help${params.length ? params : ""}`);
    toggleDrawer();
  }, [navigateTo, language, params, toggleDrawer]);

  const clickFavs = useCallback(() => {
    navigateTo(`${language}/favorites${params.length ? params : ""}`);
    toggleDrawer();
  }, [navigateTo, language, params, toggleDrawer]);

  const clickComp = useCallback(() => {
    comptoggle((a) => !a);
  }, [comptoggle]);

  const clickFilter = useCallback(() => {
    if (!filterState) {
      toggleDrawer("filter");
      setFilterState(true);
      setShowMenu(false);
    } else {
      setFilterState(false);
      toggleDrawer("filter");
      const buttons = document.querySelectorAll("button");
      buttons.forEach((button) => button.blur());
    }
  }, [filterState, toggleDrawer, setFilterState, setShowMenu]);

  const click1 = useCallback(() => {
    setIsrotate(false);
    setIsTurnBuilding(true);
  }, [setIsrotate, setIsTurnBuilding]);

  const click2 = useCallback(() => {
    setRotatemode(true);
    setIsrotate(true);
    setIsTurnBuilding(true);
  }, [setRotatemode, setIsrotate, setIsTurnBuilding]);

  const getFilterLabel = () => {
    return (
      buttonsLabel?.filter((btn) => btn.UILabelProperty === "Anvendfilter")[0]?.Label ||
      "Anvend filter"
    );
  };

  const getRotateLabel = () => {
    return (
      buttonsLabel?.filter((btn) => btn?.UILabelProperty === "Drejbygning")[0]?.Label ||
      "Drej bygning"
    );
  };

  const renderFilterButton = () => (
    <ETStyledButton
      tabIndex="0"
      role="button"
      variant="secondary"
      padding="12px 28px"
      pin={pin}
      clr={clr}
      type={projectType}
      showButton={showButton}
      onClick={clickFilter}
      isMobile={isMobile}
    >
      <Icon {...filter} isFaIcon={true} skipColorChange={true} />
      <span className="paragraph1-regular" style={{ color: "#000" }}>
        {getFilterLabel()}
      </span>
      {atList && (
        <>
          <CarratLeft />
          <CarratRight />
        </>
      )}
    </ETStyledButton>
  );

  const renderRotateButton = () => (
    <Section pin={pin} clr={clr} onClick={rotatemode && isrotate ? click1 : click2}>
      {!turnBuilding ? (
        <>
          <Icon icon="rightarrowrotate" color="#000" isFaIcon={true} size="lg" />{" "}
          {getRotateLabel()}
        </>
      ) : (
        <>
          <Icon icon={isrotate ? "pause" : "play"} color="#000" isFaIcon={true} size="lg" />{" "}
          {isrotate ? "Stop" : "play"}
        </>
      )}
    </Section>
  );

  const renderControlBox = (showRotateButton = false) => (
    <Box sx={{ position: "fixed", top: "70px", left: "0px", width: "100%" }}>
      <Box
        sx={{
          padding: "16px 16px",
          display: "flex",
          justifyContent: "space-between",
          gap: "8px",
          backgroundColor: "#EFEFEF",
          borderRadius: "6px 6px 0px 0px",
        }}
      >
        <CarratLeft />
        <CarratRight />
        {filterShouldShow && isMobile && renderFilterButton()}
        {showRotateButton && config?.IMAGE_SNAPFRAMES?.length > 0 && atModel && renderRotateButton()}
      </Box>
    </Box>
  );

  const renderCarrats = () => (
    <>
      <CarratLeft bgColor={clr.primary} shadowBg="white" />
      <CarratRight bgColor={clr.primary} shadowBg="white" />
    </>
  );
if(iFrameEnabled){
  return(
    <>
      <Foldout nav = {nav} show = {show} setShow = {setShow} />
      {/* <LanguageMenu state={state} setState={setState}/> */}
      <Menu clr = {clr} iFrameEnabled = {iFrameEnabled}> 
        <span>
          {/* <span style  = {{paddingLeft:"16px" , position:"relative"}}>
          <Logo device = "mobile" link = {logoUrl}/>
          </span> */}
          {/* {
            (
              atCompare ||
              atFavorites ||
              atDownloads ||
              atGallery) && (
                <BackButton color = {`${clr?.primary_text_passive}`}/>
            )} */}
        </span>
        {/* {(atModel || atList) && (
          !(rotatemode ) && (pin > 0 || atList) && (projectType === 'poly') && (
            <Box
              sx = {{ position: "fixed", top: "70px", left: "0px", width: "100%" }}
            >
              <Box
                sx={{
                  padding        : "16px 16px",
                  display        : "flex",
                  justifyContent : "space-between",
                  gap            : "8px",
                  backgroundColor: "#EFEFEF",
                  borderRadius   : "6px 6px 0px 0px"
                }}
              >
                 <CarratLeft></CarratLeft>
                 <CarratRight></CarratRight>
                {filterShouldShow && isMobile  &&(
                  <ETStyledButton
                   tabIndex={"0"}
                          role="button"
                  variant={"secondary"}
                  padding={"12px 28px"}
                    pin        = {pin}
                    clr        = {clr}
                    showButton = {showButton}
                    onClick    = {clickFilter}
                  >
                    <Icon {...filter} isFaIcon = {true} skipColorChange={true} />
                    <span className="paragraph1-regular" style={{color:"#000"}}>
                    {
                      buttonsLabel?.filter(
                        (btn) => btn.UILabelProperty === "Anvendfilter"
                      )[0]?.Label || "Anvend filter"
                    }
                    </span>
                  </ETStyledButton>
                )}
                {config?.IMAGE_SNAPFRAMES?.length > 0 && atModel && !showOldSlider &&(
                  <Section
                    pin     = {pin}
                    clr     = {clr}
                    onClick = {rotatemode && isrotate ? click1 : click2}
                  >
                    <>
                      {!turnBuilding ? (
                        <>
                          <Icon
                            icon     = "rightarrowrotate"
                            color    = {"#000"}
                            isFaIcon = {true}
                            size     = "lg"
                          />{" "}
                          {
                            buttonsLabel?.filter(
                              (btn) => btn?.UILabelProperty === "Drejbygning"
                            )[0]?.Label
                            || "Drej bygning"
                          }
                        </>
                      ) : (
                        <>
                          <Icon
                            icon     = {isrotate ? "pause" : "play"}
                            color    = {"#000"}
                            isFaIcon = {true}
                            size     = "lg"
                          />{" "}
                          {isrotate ? "Stop" : "play"}
                        </>
                      )}
                    </>
                  </Section>
                )}
              </Box>
            </Box>
          )
        )} */}
           {/* { ((isMobile && (pin !== 0 || !atModel)) || projectType === "mono") && atModel && <Box sx={{ width: '100%', height: '20px', background: 'white', position: 'absolute', left: '0', bottom: '-16px', borderRadius: '6px 6px 0 0' }}></Box>} */}
       {/* {
        (projectType === 'poly' && atModel && pin === 0) &&
         <>
        <CarratLeft bgColor = {clr.primary}></CarratLeft>
        <CarratRight bgColor = {clr.primary}></CarratRight>
        </>
        } */}
       
        {
          (atModel || atList)&& (pin > 0 || atList) && projectType === 'poly' && !rotatemode && (
            <Box sx = {{ position: "fixed", top: "80px", left: "0px", width: "100%" }}>
              <Box
                sx={{
                  padding        : "16px 16px",
                  display        : "flex",
                  justifyContent : "space-between",
                  gap            : "8px",
                  // backgroundColor: "#EFEFEF",
                  borderRadius   : "6px 6px 0px 0px"
                }}
              >
                  <CarratLeft></CarratLeft>
                  <CarratRight></CarratRight>
                {filterShouldShow && isMobile  &&(
                  <ETStyledButton
                  variant={"secondary"}
                  padding={"12px 28px"}
                    pin        = {pin}
                    clr        = {clr}
                    showButton = {showButton}
                    onClick    = {clickFilter}
                  >
                    <Icon {...filter} isFaIcon = {true} skipColorChange={true}/>
                     <span className="paragraph1-regular" style={{color:"#000"}}>
                    {
                      buttonsLabel?.filter(
                        (btn) => btn.UILabelProperty === "Anvendfilter"
                      )[0]?.Label || "Anvend filter"
                    }
                    </span>
                    { atList &&
                      <>
                      <CarratLeft></CarratLeft>
                      <CarratRight></CarratRight>
                      </>
                    }
                  </ETStyledButton>
                )}
                {/* {config?.IMAGE_SNAPFRAMES?.length > 0 && atModel && (
                  <Section
                    pin     = {pin}
                    clr     = {clr}
                    onClick = {rotatemode && isrotate ? click1 : click2}
                  >
                    <>
                      {!turnBuilding ? (
                        <>
                          <Icon
                            icon     = "rightarrowrotate"
                            color    = {"#000"}
                            isFaIcon = {true}
                            size     = "lg"
                          />{" "}
                          {
                            buttonsLabel?.filter(
                              (btn) => btn?.UILabelProperty === "Drejbygning"
                            )[0]?.Label
                            || "Drej bygning"
                          }
                        </>
                      ) : (
                        <>
                          <Icon
                            icon     = {isrotate ? "pause" : "play"}
                            color    = {"#000"}
                            isFaIcon = {true}
                            size     = "lg"
                          />{" "}
                          {isrotate ? "Stop" : "play"}
                        </>
                      )}
                    </>
                  </Section>
                )} */}
              </Box>
            </Box>
          )
        }
            {isIsometry && <OverviewBack />}
            {!isIsometry && !IsList && <BackButton style={{ position: "unset", gap: "8px" }} color={"#000"} />}
        <NavItems hideNav = {show}/>

        {/* <span style = {{paddingRight:"16px" , position:"relative"}}>
            <Icon {...bars} isFaIcon={true}/>
        </span> */}
        {/* { 
          isMobile && (projectType === 'mono' || pin > 0) && !(atModel || atList) && <>
          <CarratLeft  bgColor = {clr.primary} shadowBg = {'white'}></CarratLeft>
          <CarratRight bgColor = {clr.primary} shadowBg = {'white'}></CarratRight>
        </>
        } */}
      </Menu>
    </>
  );
}
else{
return (
    <>
      <Foldout nav={nav} show={show} setShow={setShow} />
      <Menu clr={clr } iFrameEnabled = {iFrameEnabled}>
        <span>
          <span style={{ paddingLeft: "16px", position: "relative" }}>
            <Logo device="mobile" link={logoUrl} />
          </span>
          {(atCompare || atFavorites || atDownloads || atGallery) && (
            <BackButton color={`${clr?.primary_text_passive}`} />
          )}
        </span>
        
        {(atModel || atList) && !rotatemode && (pin > 0 || atList) && projectType === "poly" && (
          renderControlBox(false)
        )}
        
        {(atModel || atList) && projectType === "mono" && !rotatemode && (
          renderControlBox(true)
        )}
        
        {isMobile && (projectType === "mono" || pin > 0) && !(atModel || atList) && renderCarrats()}
        
        <NavItems hideNav={show} />
        
        <span style={{ paddingRight: "16px", position: "relative" }}>
          <Icon {...bars} isFaIcon={true} />
        </span>
        
        {isMobile && (projectType === "mono" || pin > 0) && !(atModel || atList) && renderCarrats()}
      </Menu>
    </>
  );
}
  
};
